export const RouterName = {
  landiangPage: {
    homepage: "/landing-page/homepage",
    contactForm: "/landing-page/contact-form-view",
    team: "/landing-page/team",
    createTeam: "/landing-page/team/create",
    testimonials: "/landing-page/testimonials",
    createTestimonials: "/landing-page/testimonials/create",
    blog: "/landing-page/blog",
    driverVideo: "/landing-page/driver-video",
  },
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  home: {
    home: "/dashboards",
  },
  transcation: {
    transcation: "/transcation",
  },
  carTypes: {
    carTypes: "/car-types",
    createCarTypes: "/car-types/create",
  },
  cars: {
    cars: "/cars",
    createCars: "/cars/create",
  },
  make: {
    make: "/make",
    createMake: "/make/create",
  },
  model: {
    model: "/model",
    createModel: "/model/create",
  },
  promoCode: {
    promoCode: "/promo-code",
    createPromoCode: "/promo-code/create",
  },
  partner: {
    partner: "/partner",
    createPartner: "/partner/create",
  },
  loyalty: {
    loyalty: "/loyalties",
    createLoyalty: "/loyalties/create",
    loyaltyPoints: "/loyalties/points",
    redeemLoyalty: "/loyalties/redeem",
  },
  badges: {
    badges: "/badges",
    createBadge: "/badges/create",
  },
  tier: {
    tier: "/tier",
    createTier: "/tier/create",
  },
  driver: {
    driver: "/drivers",
    createDrivers: "/drivers/create",
    driverLocation: "/drivers/location",
    driverStats: "/drivers/stats",
    driverSubserviceAssignments: "/drivers/subservice-assignments",
    assignDriverSubservice: "/drivers/subservice-assignments/assign",
  },
  services: {
    services: "/services",
    createService: "/services/create",
  },
  subservices: {
    subservices: "/subservices",
    createSubservice: "/subservices/create",
  },
  charity: {
    charity: "/charity",
    charityHistory: "/charity/history",
    createCharity: "/charity/create",
  },
  preference: {
    preference: "/preference-type",
    preferenceName: "/preference",
    createPreference: "/preference-type/create",
    createPreferenceName: "/preference/create",
  },
  clientLoyalty: {
    clientLoyalty: "/loyalty",
    createClientLoyalty: "/loyalty/create",
  },
  additionalCharge: {
    additionalCharge: "/additional-charge",
    createAdditionalCharge: "/additional-charge/create",
  },
  client: {
    client: "/client",
    logs: "/logs",
    createClient: "/client/create",
  },
  clientAddress: {
    clientAddress: "/address",
    createClientAddress: "/address/create",
  },
  order: {
    order: "/order",
    createOrder: "/order/create",
    viewOrder: "/order/view/:id",
    scheduledOrder: "/order/scheduled",
    quotes: "/order/quotes",
  },
  dropOff: {
    dropOff: "/drop-off",
    createDropOff: "/drop-off/create",
  },
  orderAcitivty: {
    orderAcitivty: "/activity",
    createOrderAcitivty: "/activity/create",
  },
  zone: {
    zone: "/zone",
    createZone: "/zone/create",
  },
  settings: {
    settings: "/settings",
    createSettings: "/settings/create",
  },
  reviews: {
    reviews: "/reviews",
    listCategory: "/reviews/list-categories",
    addCategory: "/reviews/create-category",
    listSubCategory: "/reviews/list-subcategories",
    addSubCategory: "/reviews/create-subcategory",
  },
  contacts: {
    contacts: "/contacts",
  },
  broadCast: {
    broadCast: "/broadCast",
  },
  issues: {
    issues: "/issues",
  },
  admins: {
    admins: "/admins",
    addAdmins: "/admins/create",
  },
  privileges: {
    addPrivileges: "/privileges/create",
    privileges: "/privileges",
  },
};
